

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { ContentDrawer } from '@/src/views/more/knowledge/components/content-drawer';
import { Instruction } from '@/src/lib/schemas/instruction.schema';
import { BookOpen } from 'lucide-react';

export function InstructionsButton() {
  const pathname = usePathname();
  const [instructions, setInstructions] = useState<Instruction | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const loadInstructions = async () => {
      try {
        console.log('=== Instructions Button Debug ===');
        console.log('Current pathname:', pathname);
        // Log the fetch attempt
        console.log('Fetching instructions from:', '/documentation/instructions.json');
        const response = await fetch('/documentation/instructions.json');
        if (!response.ok) {
          console.error('Failed to fetch instructions:', response.status, response.statusText);
          return;
        }

        const data = await response.json();

        // Find matching instruction based on URL pattern
        const matchingInstruction = data.find(
          (instruction: Instruction) => {
            if (instruction.url === pathname) {
              return true;
            }
            // Special handling for campaign edit URLs
            if (instruction.url === '/campaigns/edit' && pathname.startsWith('/campaigns/edit/')) {
              return true;
            }

            return false;
          }
        );

        if (matchingInstruction) {
          setInstructions(matchingInstruction);
        } else {
          console.log('No matching instruction found for current pathname');
          setInstructions(null);
        }
      } catch (error) {
        console.error('Error loading instructions:', error);
        setInstructions(null);
      }
    };

    loadInstructions();
  }, [pathname]);

  if (!instructions) {
    return null;
  }

  return (
    <>
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed right-0 top-1/2 -translate-y-1/2 bg-white hover:bg-gray-50 rounded-l-full p-3 shadow-lg border border-r-0 border-gray-200 group z-50 transition-all duration-300 hover:scale-110"
          title="View Instructions"
        >
          <BookOpen className="w-6 h-6 text-blue-600 transition-colors duration-300 group-hover:text-blue-700" />
        </button>
      )}
      <ContentDrawer
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        instruction={instructions}
      />
    </>
  );
}
